import { mapGetters } from "vuex";
import moment from "moment";
import "firebase/firestore";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
export default {
  data() {
    return {};
  },
  mixins: [dataSources, displayFunctions],
  computed: {
    ...mapGetters(["getUser", "getDataSource"])
  },
  methods: {
    generateDID(type, tag) {
      // db doc that is created.
      const db = this.dbUser; // db reference
      let temp = db.doc().id;
      let did = null; // to be assigned
      // CHECK
      if (type == "AUTO") {
        did = tag + temp;
      }
      if (type == "DATE") {
        let y = moment().format("YYYY");
        let m = moment().format("MM");
        let d = moment().format("DD");
        did = y + m + d + tag + temp;
      }
      return did;
    },
    generateAUTODID(tag) {
      const db = this.defineDataSourceFromTag(tag);
      const did = db.doc().id;
      return did;
    },
    generateHistoryDID(did) {
      let h = "H" + did;
      return h;
    },
    displayDocumentIDGTypeA(tag, num) {
      let idg = num.toString();
      idg = idg.slice(-6);
      idg = tag + idg;
      return idg;
    },
    generateIDfromMaster(tag, num, index) {
      let id = null;
      let idg = num.toString();
      let idx = null;
      index = index + 1;
      // DEFINE Index
      if (index < 9) {
        idx = index.toString();
        idx = "0" + idx;
      } else {
        idx = index.toString();
      }
      id = tag + idg.slice(-4) + idx;
      return id;
    },
    generateIDMaintCall(tag, num, index) {
      let id = null;
      let idg = num.toString();
      let idx = null;
      index = index + 1;
      // DEFINE Index
      if (index < 9) {
        idx = index.toString();
        idx = "0" + idx;
      } else {
        idx = index.toString();
      }
      id = tag + idg.slice(-6) + idx;
      return id;
    },
    generateMaintPlanIDfromMaintActivity(tag, num, item, index) {
      let id = null;
      let idg = num.toString();
      let idx = null;
      let jdx = null;
      index = index + 1;

      if (item < 9) {
        idx = item.toString();
        idx = "0" + idx;
      } else {
        idx = index.toString();
      }
      // DEFINE Index
      if (index < 9) {
        jdx = index.toString();
        jdx = "0" + jdx;
      } else {
        jdx = index.toString();
      }
      id = tag + idg.slice(-4) + idx + jdx;
      return id;
    },
    generateIDG(type) {
      let gid = null;
      if (type === "date-gid") {
        // generate miliseconds
        gid = moment().format("x");
      }
      gid = parseInt(gid);
      return gid;
    },
    generateNextSeriesText(text) {
      let temp = text;
      let n = text.length;
      if (text !== null && n > 3) {
        // GET LAST THREE CHAR.
        let x = text.charAt(n - 1);
        let y = text.charAt(n - 2);
        let z = text.charAt(n - 3);
        // CONVETR TO INTGER
        x = parseInt(x);
        y = parseInt(y);
        z = parseInt(z);
        // GENERATE NEW TEXT
        // CASE 1 single digit
        if (!isNaN(x) && isNaN(y)) {
          let num = x + 1;
          temp = temp.slice(0, n - 1);
          temp = temp + num;
        } else if (!isNaN(x) && !isNaN(y) && isNaN(z)) {
          let num = temp.substr(n - 2);
          num = parseInt(num);
          num = num + 1;
          temp = temp.slice(0, n - 2);
          temp = temp + num;
        } else if (!isNaN(x) && !isNaN(y) && !isNaN(z)) {
          let num = temp.substr(n - 3);
          num = parseInt(num);
          num = num + 1;
          temp = temp.slice(0, n - 3);
          temp = temp + num;
        } else {
          temp = text + " UNDEFINED";
        }
        console.log(x);
        console.log(y);
        console.log(z);
      } else {
        temp = text + " ADDED";
      }
      console.log("");
      console.log(">>> GENERATE NEXT SERIES TEXT <<<");
      console.log(temp);
      return temp;
    }
  }
};
